import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
// import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import {
  Autocomplete,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import states from "./states";


// const filter = createFilterOptions();
const bingKey = 'AsWiqgsJtBn48XSjMa56Jr6XQs3T3q70-N6i1OEf7Vq8RAkYpNbcVlzHvYbqP1cp'
const APIURL = `https://dev.virtualearth.net/REST/v1/Autosuggest`;

// Example POST method implementation:
async function getData(url = '') {
  // Default options are marked with *
  const response = await fetch(url, {
    method: 'GET', // *GET, POST, PUT, DELETE, etc.
    // mode: 'no-cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'text/plain'
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer',
    // body: JSON.stringify(data) // body data type must match "Content-Type" header
  });
  return response.json(); // parses JSON response into native JavaScript objects
}

// async function getOptions(params) {
//   let optionsData = [];
//   const searchString = params.inputValue;

//   if (searchString) {
//     const APIQuery = `?query=${encodeURI(searchString)}&key=${bingKey}&countryFilter=us`;
//     const fullAPIURL = APIURL + APIQuery;

//     optionsData = await getData(fullAPIURL)
//       .then(data => {
//         console.log(data); // JSON data parsed by `data.json()` call
//         let bingData = [];
//         const resources = data.resourceSets[0]?.resources[0]?.value;
//         if (resources.length) {
//           bingData = resources.map((option) => ({
//               title: option.address.formattedAddress,
//               value: option.address
//           }))
//           // optionsData = bingData;
//         }
//         console.log('bingData', bingData);
//         return bingData;
//       })
//       .catch((error) => {
//         console.log('getData error', error);
//       });
//   }
//   return optionsData;
// }

export default function AddressLookup({
  name,
  control,
  label,
  placeholder,
  register,
  setValue,
  watchedValues
}) {
  // const [search, setSearch] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [searchValue, setSearchValue] = useState(null);
  const [inputValue, setInputValue] = useState(null);

  // console.log(`stateValue ${name}_state`, watchedValues[`${name}_state`]);

  useEffect(() => {
    // console.log('search', inputValue);
    // let optionsData = [];

    if (inputValue && inputValue !== '') {
      setIsLoading(true);
      const APIQuery = `?query=${encodeURI(inputValue)}&key=${bingKey}&countryFilter=us`;
      const fullAPIURL = APIURL + APIQuery;

      getData(fullAPIURL)
        .then(data => {
          // console.log(data); // JSON data parsed by `data.json()` call
          let optionsData = [];
          const resources = data.resourceSets[0]?.resources[0]?.value;
          if (resources.length) {
            optionsData = resources.filter((element, index) => index < 5)
            .map((option) => ({
                title: option.address.formattedAddress,
                value: option
            }));
            // optionsData = bingData;
          }
          // optionsData.push({
          //   title: inputValue,
          //   value: {
          //     address1: inputValue,
          //     customAddress: true,
          //   }
          // })
          // console.log('optionsData', optionsData);
          setOptions(optionsData);
          setIsLoading(false);
        })
        .catch((error) => {
          console.log('getData error', error);
          setOptions([]);
          setIsLoading(false);
        });
    }
    else {
      setOptions([]);
    }

    return () => {
      setOptions([]);
      setIsLoading(false);
    }
  }, [searchValue, inputValue]);



    // if (!loading) {
    //   return undefined;
    // }

  //   (async () => {
  //     if (active) {
  //       // console.log('value', value);
  //       const APIQuery = `?query=${encodeURI('')}&key=${bingKey}&countryFilter=us`;
  //       const fullAPIURL = APIURL + APIQuery;

  //       getData(fullAPIURL)
  //         .then(data => {
  //           console.log(data); // JSON data parsed by `data.json()` call
  //           let bingData = [];
  //           const resources = data.resourceSets[0]?.resources[0]?.value;
  //           if (resources.length) {
  //             bingData = resources.map((option) => ({
  //                 title: option.address.formattedAddress,
  //                 value: option.address
  //             }))
  //             setOptionsData(bingData);
  //           }
  //           console.log(bingData);
  //         })
  //         .catch((error) => {
  //           console.log('getData error', error);
  //           setOptionsData(null);
  //         });

  //       // .then((response) => {

  //       // })
  //       // .catch((err) => {
  //       //   setError(err.message);
  //       //   setOptions(null);
  //       // })
  //       // .finally(() => {

  //       // });
  //     }
  //   })();

  //   return () => {
  //     active = false;
  //   };
  // }, [loading]);


  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Controller
          control={control}
          name={`${name}`}
          render={({ field: { onChange } }) => (
            <Autocomplete
              control={control}
              // value={value}
              id={`${name}`}
              onChange={(event, newValue) => {
                if (typeof newValue === 'string') {
                  setSearchValue({
                    title: newValue,
                  });
                } else if (newValue && newValue.inputValue) {
                  // Create a new value from the user input
                  setSearchValue({
                    title: newValue.inputValue,
                  });
                }
                else {
                  setSearchValue(newValue);
                }
                onChange(newValue);
              }}
              filterOptions={(x) => x}
              onInputChange={(event, newInputValue) => {
                //console.log('newInputValue', newInputValue)
                setInputValue(newInputValue);
                setValue(`${name}_address1`, newInputValue);
              }}
              selectOnFocus
              handleHomeEndKeys
              // id="free-solo-with-text-demo"
              options={options}
              getOptionLabel={(option) => {
                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                  return option;
                }
                // // Add "xxx" option created dynamically
                if (option.inputValue) {
                  return option.inputValue;
                }
                // Regular option
                return option.value?.address?.addressLine;
              }}
              renderOption={(props, option) => (
                // console.log('renderOption option', option)
                // console.log('renderOption props', props)
                // return (
                  <li
                    {...props}
                    key={props.id}
                  >
                    {option.title}
                  </li>
                // )
              // }
              )}
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  name={`${name}_lookup`}
                  // value={watchedValues[`${name}`]?.value?.address?.addressLine || ''}
                  control={control}
                  label={label}
                  // name={name}
                  placeholder={placeholder}
                  required
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {isLoading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : (
                          <InputAdornment position="start">
                            <IconButton>
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        )}
                        {params.InputProps.endAdornment}
                      </>
                    )
                  }}
                />
              )}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          className="w-full"
          {...register(`${name}_address2`)}
          label="Address Line 2"
          placeholder="Unit 123"
          // error={errors[`${name}_address2`]}
          value={watchedValues[`${name}_address2`] || ''}
        />
      </Grid>
      <Grid item xs={5}>
        <TextField
          className="w-full"
          {...register(`${name}_city`)}
          label="City"
          placeholder="Chicago"
          required
          // error={errors[`${name}_city`]}
          value={watchedValues[`${name}_city`] || ''}
        />
      </Grid>
      <Grid item xs={4}>
      <FormControl fullWidth>
        <Controller
          control={control}
          name={`${name}_state`}
          render={({ field }) => (
            <>
              <InputLabel id={`${name}_state_label`}>
                State
              </InputLabel>
              <Select
                // error={errors[`${name}_city`]}
                labelId={`${name}_state_label`}
                id={`${name}_state`}
                label="State"
                required
                {...field}
                // {...register(`${name}_state`)}
              >
                {states.map((item) =>
                  <MenuItem value={item.name}>{item.name}</MenuItem>
                )}
              </Select>
            </>
          )}
        />
        </FormControl>
      </Grid>
      <Grid item xs={3}>
        <TextField
          className="w-full"
          {...register(`${name}_zip`)}
          label="Zip Code"
          placeholder="00000"
          // error={errors[`${name}_zip`]}
          max={5}
          value={watchedValues[`${name}_zip`] || ''}
        />
      </Grid>
    </Grid>
  )
}


// const filter = createFilterOptions();

// const bingKey = 'AsWiqgsJtBn48XSjMa56Jr6XQs3T3q70-N6i1OEf7Vq8RAkYpNbcVlzHvYbqP1cp'
// const APIURL = `https://dev.virtualearth.net/REST/v1/Autosuggest`;

// // Example POST method implementation:
// async function getData(url = '') {
//   // Default options are marked with *
//   const response = await fetch(url, {
//     method: 'GET', // *GET, POST, PUT, DELETE, etc.
//     // mode: 'no-cors', // no-cors, *cors, same-origin
//     cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
//     credentials: 'same-origin', // include, *same-origin, omit
//     headers: {
//       'Content-Type': 'text/plain'
//       // 'Content-Type': 'application/x-www-form-urlencoded',
//     },
//     redirect: 'follow', // manual, *follow, error
//     referrerPolicy: 'no-referrer',
//     // body: JSON.stringify(data) // body data type must match "Content-Type" header
//   });
//   return response.json(); // parses JSON response into native JavaScript objects
// }

// function AddressLookup({
//   name,
//   control,
//   label,
//   placeholder
// }) {
//   // const [error, setError] = useState(null);
//   const [open, setOpen] = useState(false);
//   const [optionsData, setOptionsData] = useState([]);
//   // const [value, setValue] = useState(null);
//   const loading = open && optionsData.length === 0;

//   console.log('watch', useWatch());

//   // const handleSearch = (event, value) => {
//   //   console.log('handleSearch event', event);
//   //   console.log('handleSearch value', value);
//   //   setSearch(value);
//   // }

//   useEffect(() => {
//     let active = true;

//     // if (!loading) {
//     //   return undefined;
//     // }

//     (async () => {
//       if (active) {
//         // console.log('value', value);
//         const APIQuery = `?query=${encodeURI('')}&key=${bingKey}&countryFilter=us`;
//         const fullAPIURL = APIURL + APIQuery;

//         getData(fullAPIURL)
//           .then(data => {
//             console.log(data); // JSON data parsed by `data.json()` call
//             let bingData = [];
//             const resources = data.resourceSets[0]?.resources[0]?.value;
//             if (resources.length) {
//               bingData = resources.map((option) => ({
//                   title: option.address.formattedAddress,
//                   value: option.address
//               }))
//               setOptionsData(bingData);
//             }
//             console.log(bingData);
//           })
//           .catch((error) => {
//             console.log('getData error', error);
//             setOptionsData(null);
//           });

//         // .then((response) => {

//         // })
//         // .catch((err) => {
//         //   setError(err.message);
//         //   setOptions(null);
//         // })
//         // .finally(() => {

//         // });
//       }
//     })();

//     return () => {
//       active = false;
//     };
//   }, [loading]);

//   useEffect(() => {
//     if (!open) {
//       setOptionsData([]);
//     }
//   }, [open]);

//   return (
//     <Controller
//       control={control}
//       name={name}
//       render={() => (
//         <Autocomplete
//           className="w-full"
//           open={open}
//           onOpen={() => {
//             setOpen(true);
//           }}
//           onClose={() => {
//             setOpen(false);
//           }}
//           // onChange={(event, value) => handleSearch(event, value)}
//           // isOptionEqualToValue={(option, value) => option.title === value.title}
//           // getOptionLabel={(option) => option.title}
//           // options={options}
//           loading={loading}
//           // value={value}
//           filterOptions={(options, params) => {
//             const filtered = filter(options, params);

//             const { inputValue } = params;
//             // Suggest the creation of a new value
//             const isExisting = options.some((option) => inputValue === option.title);
//             if (inputValue !== '' && !isExisting) {
//               filtered.push({
//                 inputValue,
//                 title: `Add "${inputValue}"`,
//               });
//             }

//             return filtered;
//           }}
//           selectOnFocus
//           clearOnBlur
//           handleHomeEndKeys
//           options={optionsData}
//           getOptionLabel={(option) => {
//             // Value selected with enter, right from the input
//             if (typeof option === 'string') {
//               return option;
//             }
//             // Add "xxx" option created dynamically
//             if (option.inputValue) {
//               return option.inputValue;
//             }
//             // Regular option
//             return option.title;
//           }}
//           renderOption={(props, option) => <li {...props}>{option.title}</li>}
//           freeSolo
//           renderInput={(params) => (
//             <TextField
//               {...params}
//               className="w-full"
//               control={control}
//               label={label}
//               name={name}
//               placeholder={placeholder}
//               InputProps={{
//                 ...params.InputProps,
//                 endAdornment: (
//                   <>
//                     {loading ? (
//                       <CircularProgress color="inherit" size={20} />
//                     ) : null}
//                     {params.InputProps.endAdornment}
//                   </>
//                 ),
//               }}
//             />
//           )}
//         />
//       )}
//     />
//   );
// };

// export default AddressLookup;
